import "./index.scss";

export default function WaveHeader({
  projectName,
  handleProjectNameClick = null,
  Count_Of_PMPs,
}) {
  
  return (
    <div className="mb-3">
      <div className="project-details">
        <div className="mb-4">
          <label>Project Name</label>
          <button onClick={() => handleProjectNameClick()}>{projectName || ""}</button>
        </div>
    </div>
      <div className="project-details"> 
        <label>There are {Count_Of_PMPs} PMP's in scope of the DSBP, accordingly distribute them into waves.</label>
      </div>
    </div>
  );
}
